export async function scrollToElement(path, elementId, router) {
  if (router.asPath !== path) await router.push(path)

  const activeClassNames = ['bg-sky-200']
  const element = document.getElementById(elementId)

  if (element) {
    window.scrollTo({
      top: element.getBoundingClientRect().top + window.scrollY - 350,
      behavior: 'smooth',
    })
    // Flash the DOM
    setTimeout(() => {
      element.classList.add(...activeClassNames)
    }, 500)
    setTimeout(() => {
      element.classList.remove(...activeClassNames)
    }, 700)
  }
}
